import { NotificationManager } from "react-notifications";
import { createRequest } from "@/components/common/helpers/RequestHelpers";
import apiURL from "./apiURL";

const leaveAdjustmentRequest = createRequest({
	urlPath: "/settings/leaveAdjustments/",
	local: false,
});

const Types = {
	LEAVE_ADJUSTMENT_UPDATE: "LEAVE_ADJUSTMENT_UPDATE",
	LEAVE_ADJUSTMENT_OPEN_MODAL: "LEAVE_ADJUSTMENT_OPEN_MODAL",
	LEAVE_ADJUSTMENT_CANCEL: "LEAVE_ADJUSTMENT_CANCEL",
	LEAVE_ADJUSTMENT_SHOW_COMMENTS: "LEAVE_ADJUSTMENT_SHOW_COMMENTS",
	LEAVE_ADJUSTMENT_SHOW_ATTACHMENTS: "LEAVE_ADJUSTMENT_SHOW_ATTACHMENTS",
	LEAVE_ADJUSTMENT_SAVE_CURRENT: "LEAVE_ADJUSTMENT_SAVE_CURRENT",
	LEAVE_ADJUSTMENT_SAVING: "LEAVE_ADJUSTMENT_SAVING",
	LEAVE_ADJUSTMENT_IMPORT_SHOW_MODAL: "LEAVE_ADJUSTMENT_IMPORT_SHOW_MODAL",
	LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSING: "LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSING",
	LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSED: "LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSED",
	LEAVE_ADJUSTMENT_IMPORT_UPLOAD_TEMPLATE: "LEAVE_ADJUSTMENT_IMPORT_UPLOAD_TEMPLATE",
	LEAVE_ADJUSTMENT_FILE_UPLOADING: "LEAVE_ADJUSTMENT_FILE_UPLOADING",
	LEAVE_ADJUSTMENT_FILE_UPLOADED: "LEAVE_ADJUSTMENT_FILE_UPLOADED",
	LEAVE_ADJUSTMENT_REPORT_DOWNLOADING: "LEAVE_ADJUSTMENT_REPORT_DOWNLOADING",
};

const leaveAdjustmentUpdateSaveStatus = (response, leaveAdj) => ({
	type: Types.LEAVE_ADJUSTMENT_SAVE_CURRENT,
	payload: response,
	leaveAdj,
});

const leaveAdjustmentSetSaving = (id) => ({
	type: Types.LEAVE_ADJUSTMENT_SAVING,
	id,
});

const saveLeaveAdjustment = (leaveAdj) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(leaveAdjustmentSetSaving((leaveAdj && leaveAdj.id) || true));

		const path = "/settings/leaveAdjustments/";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(leaveAdj),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);

				dispatch(leaveAdjustmentUpdateSaveStatus(data, leaveAdj));
			});
	};
};

const updateLeaveAdjustments = (data) => ({
	type: Types.LEAVE_ADJUSTMENT_UPDATE,
	data: data,
});

const setOpenLeaveAdjustmentModal = (status, leaveAdj) => ({
	type: Types.LEAVE_ADJUSTMENT_OPEN_MODAL,
	status: status,
	leaveAdj,
});

const showCancelLeaveAdjustment = (leaveAdj, status) => ({
	type: Types.LEAVE_ADJUSTMENT_CANCEL,
	status,
	leaveAdj,
});

const showLeaveAdjustmentComments = (leaveAdj) => ({
	type: Types.LEAVE_ADJUSTMENT_SHOW_COMMENTS,
	leaveAdj,
});

const showLeaveAdjustmentAttachments = (leaveAdj) => ({
	type: Types.LEAVE_ADJUSTMENT_SHOW_ATTACHMENTS,
	leaveAdj,
});

const getLeaveAdjustmentsByAgreement = ({ agreementId, options }) => {
	return (dispatch, getState) => {
		const state = getState();

		const qs = new URLSearchParams(options).toString();
		// test data
		fetch(apiURL + `/settings/leaveAdjustments/agreement/${agreementId}?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(updateLeaveAdjustments(data.leaveAdjustment)));
	};
};

const getLeaveAdjustmentsByOrg = (options) => {
	return (dispatch, getState) => {
		const qs = new URLSearchParams(options).toString();
		fetch(apiURL + `/settings/leaveAdjustments?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(updateLeaveAdjustments(data.leaveAdjustment)));
	};
};

const showImportModal = (status) => ({
	type: Types.LEAVE_ADJUSTMENT_IMPORT_SHOW_MODAL,
	status,
});

const setLeaveAdjustmentImportDataProcessing = (key) => ({
	type: Types.LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSING,
	key,
});

const setLeaveAdjustmentImportDataProcessed = (processed, errors, warnings) => ({
	type: Types.LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSED,
	processed,
	errors,
	warnings,
});

const handleLeaveAdjustmentUpload = ({ key, org, replaceExisting }) => {
	return (dispatch, getState) => {
		dispatch(setLeaveAdjustmentImportDataProcessing(key));

		const path = "/settings/upload/leaveAdjustment";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				key,
				org,
				replaceExisting,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
					NotificationManager.error("Error processing leave adjustment import", "Import Leave Adjustments");
					return;
				}
				dispatch(setLeaveAdjustmentImportDataProcessed(data.processed, data.errors, data.warnings));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error processing leave adjustment import", "Import Leave Adjustments");
				dispatch(setLeaveAdjustmentImportDataProcessing());
			});
	};
};

const leaveAdjustmentImportTemplateDownloaded = (template) => ({
	type: Types.LEAVE_ADJUSTMENT_IMPORT_UPLOAD_TEMPLATE,
	template,
});

const getLeaveAdjustmentImportTemplate = () => {
	return (dispatch, getState) => {
		fetch(apiURL + "/settings/upload/leaveAdjustment", {
			method: "GET",
			credentials: "include",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				dispatch(leaveAdjustmentImportTemplateDownloaded(data.template));
			})
			.catch((err) => console.error(err));
	};
};

const setFileUploading = (file) => ({
	type: Types.LEAVE_ADJUSTMENT_FILE_UPLOADING,
	file,
});

const setFileUploaded = (file, key) => ({
	type: Types.LEAVE_ADJUSTMENT_FILE_UPLOADED,
	file,
	key,
});

const uploadFile = ({ file, agreement }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = "/settings/upload";

		// NotificationManager.success('Your File is being uploaded','Info')
		dispatch(setFileUploading(file.name));

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				name: file.name,
				type: file.type,
				agreement,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("getImportStatus", data);

				const fileKey = data.key;

				// step 1 upload to AWS
				fetch(data.url, {
					credentials: "include",
					method: "PUT",
					body: file,
					headers: {
						"Accept": "application/json",
						"Content-Type": file.type,
					},
				}).then((data) => {
					dispatch(setFileUploaded(file.name, fileKey));
				});
			});
	};
};

const calculateBackdatePH = (org, publicHoliday) => {
	return async (dispatch, getState) => {
		await leaveAdjustmentRequest({
			method: "GET",
			path: `calculateBackdatePH/${org}`,
			query: { publicHoliday },
		})
			.then(() => {
				NotificationManager.success(
					"Sucesfully calculated Backdated Public Holidays",
					"Calculate Backdated Public Holidays",
				);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(
					"Error calculating Backdated Public Holidays",
					"Calculate Backdated Public Holidays",
				);
			});
	};
};

const downloadReport = (data) => {
	return (dispatch, getState) => {
		dispatch(setReportDownloading(true));

		const qs = new URLSearchParams(data).toString();

		leaveAdjustmentRequest({
			method: "GET",
			path: `download/report?${qs}`,
		})
			.then((response) => {
				const signedURL = response?.data?.signedURL;

				if (signedURL) {
					const popup = window.open(signedURL);

					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
				}

				dispatch(setReportDownloading(false));
			})
			.catch((error) => {
				NotificationManager.error("There was a problem creating your report", "Download Report");
			});
	};
};

const setReportDownloading = (status) => ({
	type: Types.LEAVE_ADJUSTMENT_REPORT_DOWNLOADING,
	status,
});

const Actions = {
	getLeaveAdjustmentsByAgreement,
	getLeaveAdjustmentsByOrg,
	setOpenLeaveAdjustmentModal,
	saveLeaveAdjustment,
	showCancelLeaveAdjustment,
	showLeaveAdjustmentComments,
	showLeaveAdjustmentAttachments,
	showImportModal,
	handleLeaveAdjustmentUpload,
	getLeaveAdjustmentImportTemplate,
	uploadFile,
	calculateBackdatePH,
	downloadReport,
	setReportDownloading,
};

export { Types, Actions };
